"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../../Table.css");
var Tr_1 = require("../Tr");
var RowGroup = /** @class */ (function (_super) {
    __extends(RowGroup, _super);
    function RowGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            collapsible: false,
            expanded: true,
        };
        _this.collasibleKeyValue = false;
        _this.toggleCollapse = _this.toggleCollapse.bind(_this);
        _this.renderChildren = _this.renderChildren.bind(_this);
        return _this;
    }
    RowGroup.prototype.componentDidMount = function () {
        var rows = React.Children.toArray(this.props.children).filter(function (child) { return child.type === Tr_1.default; });
        this.setState({
            collapsible: this.props.options && this.props.options.collapsible &&
                rows.length > this.props.options.collapseFrom,
            expanded: !(this.props.options && this.props.options.collapsible &&
                rows.length > this.props.options.collapseFrom),
        });
    };
    RowGroup.prototype.toggleCollapse = function (e) {
        if (!this.state.collapsible) {
            return;
        }
        this.setState({ expanded: !this.state.expanded });
        if (this.props.events && this.props.events.onToggleCollapse) {
            this.props.events.onToggleCollapse(e);
        }
    };
    RowGroup.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.options.sortOrder !== this.props.options.sortOrder) {
            this.setState({ expanded: false });
        }
    };
    RowGroup.prototype.render = function () {
        var _a = this.state, collapsible = _a.collapsible, expanded = _a.expanded;
        var classnames = [styles.rowGroup, this.props.options.className];
        return (React.createElement("tbody", { className: classnames.join(' '), "data-test-id": this.props.testId },
            this.renderChildren(),
            React.createElement("tr", { className: styles.seperatorRow, role: 'presentation', "aria-hidden": true },
                React.createElement("td", { colSpan: 100 },
                    React.createElement("div", null)))));
    };
    RowGroup.prototype.renderChildren = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child, index) {
            if (!child) {
                return;
            }
            if (child.type !== Tr_1.default) {
                // tslint:disable-next-line:no-console
                console.error(child.type + " is not allowed child of RowGroup component");
                return null;
            }
            var i = 0;
            if (index === 0 && _this.props.children[1]) {
                var childRowData = _this.props.data[_this.props.rowIndex].childRows;
                if (_this.props.options.collapsibleKey) {
                    for (i = 0; i < childRowData.length; i++) {
                        if (_this.props.options.collapsibleKey in childRowData[i]) {
                            _this.collasibleKeyValue = true;
                        }
                    }
                }
                _this.rowCount = _this.collasibleKeyValue ? _this.rowCount = 0 : _this.props.children[1].length;
            }
            var classnames = index >= _this.props.options.collapseFrom
                ? [child.props.options.className, styles.childRow].join(' ')
                : child.props.options.className;
            var childData = index >= _this.props.options.collapseFrom
                ? 'childRow'
                : 'row';
            if (_this.state.expanded) {
                classnames = index >= 1
                    ? [child.props.options.className, styles.childRow].join(' ')
                    : child.props.options.className;
                childData = index >= 1
                    ? 'childRow'
                    : 'row';
            }
            return React.cloneElement(child, {
                events: __assign(__assign({}, child.props.events), { onToggleCollapse: _this.toggleCollapse }),
                options: __assign(__assign({}, child.props.options), { className: classnames, collapsible: _this.state.collapsible, expanded: _this.state.expanded, indexNo: index, rowCount: _this.rowCount, dataChildRow: childData }),
            });
        });
    };
    RowGroup.defaultProps = {
        options: {
            className: '',
            collapseFrom: 1,
        },
    };
    return RowGroup;
}(React.Component));
exports.default = RowGroup;
//# sourceMappingURL=RowGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/RowGroup/RowGroup.js
// module id = 1373
// module chunks = 8